@if (filterChip && filterChip.length == 2) {
  <span calltoaction [calltoactionTemplate]="filterChipToolTipIcon" [calltoactionUsesHover]="true">{{(filterChip[1].filterType==='set')? '(' + filterChip[1].values.length +') ' + getDisplayName() : getDisplayName()}}</span>
  <img class="btn-action-close-delete chip-delete-icon" (click)="removeFilter()" title="remove filter" width="14" height="14" />
  <ng-template #filterChipToolTipIcon>
    @if (filterChip[1].filterType === 'set') {
      <div class="filter-chip-type-set">
        <ul>@for (filterChipValue of filterChip[1].values; track filterChipValue; let i = $index) {
          @if (i < 10) {
            <li> {{getValueMap(filterChipValue)}}</li>
          }
        }
      </ul>
      @if (filterChip[1].values?.length>10) {
        <div style="padding-top: 10px;"><img  src="../../assets/images/warning.png" class="not-all-showing-img "><span class="not-all-showing-span-text">Not all items are showing</span></div>
      }
    </div>
  }
  @if (filterChip[1].filterType === 'setByName') {
    <div class="filter-chip-type-set">
      <ul>@for (filterChipValue of filterChip[1].displayValues; track filterChipValue; let i = $index) {
        @if (i < 10) {
          <li> {{filterChipValue}}</li>
        }
      }
    </ul>
    @if (filterChip[1].displayValues?.length>10) {
      <div style="padding-top: 10px;"><img  src="../../assets/images/warning.png" class="not-all-showing-img "><span class="not-all-showing-span-text">Not all items are showing</span></div>
    }
  </div>
}
@if (filterChip[1].filterType === 'text') {
  <div class="filter-chip-type-text">
    <div>{{filterChip[1].filter}}</div>
  </div>
}
@if (filterChip[1].filterType === 'IrbAgSingleSelectColumnFilterComponent') {
  <div class="filter-chip-type-text">
    <div>{{filterChip[1].value}}</div>
  </div>
}
@if (filterChip[1].filterType === 'number') {
  <div class="filter-chip-type-number">
    @if (filterChip[1].type === 'inRange') {
      <div>{{filterChip[1].filter}} - {{filterChip[1].filterTo}}</div>
    }
    @if (filterChip[1].type !== 'inRange') {
      <div>{{filterChip[1].filter}}</div>
    }
  </div>
}
@if (filterChip[1].filterType === 'date') {
  <div class="filter-chip-type-date">
    @if (filterChip[1].type === 'inRange') {
      <div>From: {{filterChip[1].dateFrom}} To: {{filterChip[1].dateTo}}</div>
    }
    @if (filterChip[1].type !== 'inRange') {
      <div>{{filterChip[1].dateFrom}}</div>
    }
  </div>
}
@if (filterChip[1].filterType === 'IrbAgDateColumnFilter') {
  <div class="filter-chip-type-date">
    <div>From: {{filterChip[1].filterFrom | date:'MM/dd/yyyy' }} To: {{filterChip[1].filterTo | date:'MM/dd/yyyy'}}</div>
  </div>
}
@if (filterChip[1].filterType === 'IrbAgNumberColumnFilterComponent') {
  <div class="filter-chip-type-number">
    <div>
      @if (filterChip[1].filter) {
        <span>{{ getFormattedValue(filterChip[1].filter)}}</span>
      }
      @if (!filterChip[1].filter) {
        <span>Min</span>
      }
      -
      @if (filterChip[1].filterTo) {
        <span>{{getFormattedValue(filterChip[1].filterTo)}}</span>
      }
      @if (!filterChip[1].filterTo) {
        <span>Max</span>
      }
    </div>
  </div>
}
@if (filterChip[1].filterType === 'quickFilter') {
  <div class="filter-chip-type-number">
    <div>{{filterChip[1].value}}</div>
  </div>
}
</ng-template>
}
